export { EloPayLaterEnIcon } from './pay-later-en-icon'
